// Graupner Butler – Bedienleiste (B-2, erster Entwicklungsschritt).
// Beim Laden immer AUS. „Butler aktivieren“ startet die Ablaufaufzeichnung sofort; währenddessen ist
// ein auffälliger Streifen „● Butler AKTIV – zeichnet auf“ dauerhaft sichtbar, mit „Butler beenden“.
// Es wird NUR die vorhandene, datenschutzgefilterte Aufzeichnung geschaltet – keine neuen Daten.
// B-3: Im aktiven Streifen „Fehler gefunden“ und „Nicht reproduzierbar“ (Fehlerakte BUT-0001 …).
// Handy (15.10.2026): Streifen bricht um (Text oben, Knöpfe darunter), alle drei Knöpfe bei 360 px erreichbar.
// Einschalten und „Fehlerakten“ (15.10.2026, Ralph): nicht mehr als schwebende Knöpfe, sondern als Einträge
// in der Navigation (layout/Navigation.jsx). Diese Leiste zeigt nur noch den roten Streifen bei aktivem Butler.
import { useEffect, useState } from "react";
import { butlerIstAktiv, butlerBeenden, butlerBeobachten } from "../lib/ablauf";
import FehlerGefundenDialog from "./FehlerGefundenDialog";

export default function ButlerLeiste() {
  const [aktiv, setAktiv] = useState(butlerIstAktiv());
  const [dialog, setDialog] = useState(null); // null | "fehler" | "ohne_fehler"

  useEffect(() => butlerBeobachten(setAktiv), []);

  // Nur für angemeldete Nutzer sichtbar.
  let angemeldet = false;
  try { angemeldet = !!localStorage.getItem("token"); } catch { /* egal */ }
  // Butler aus: nichts anzeigen (Einschalten über den Navigationseintrag „Butler“).
  if (!angemeldet || !aktiv) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="butler-streifen"
      // Der Streifen ist ein direktes Kind von .App; App.css setzt dort „.App > div { min-height: 100vh }“.
      // Ohne diese Ausnahme wäre der Streifen bildschirmhoch (App.css bleibt bewusst unverändert).
      style={{ minHeight: 0 }}
      className="fixed top-0 inset-x-0 z-[9999] flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 bg-red-600 text-white px-2 sm:px-4 py-1.5 sm:py-2 shadow-lg"
    >
      <span className="flex w-full sm:w-auto items-center justify-center gap-2">
        <span className="inline-block h-3 w-3 shrink-0 rounded-full bg-white animate-pulse" aria-hidden="true" />
        <span className="text-sm sm:text-base font-semibold tracking-wide">Butler AKTIV – zeichnet auf</span>
      </span>
      <span className="flex w-full sm:w-auto flex-wrap items-stretch justify-center gap-1.5 sm:gap-2">
        <button
          type="button"
          onClick={() => setDialog("fehler")}
          data-testid="butler-fehler-gefunden"
          className="flex-1 sm:flex-none min-w-[5.5rem] rounded bg-yellow-300 px-2 sm:px-3 py-1 text-xs sm:text-sm leading-tight font-bold text-red-900 hover:bg-yellow-200"
        >
          Fehler gefunden
        </button>
        <button
          type="button"
          onClick={() => setDialog("ohne_fehler")}
          title="Ablauf wiederholt – Fehler trat diesmal nicht auf"
          data-testid="butler-nicht-reproduzierbar"
          className="flex-1 sm:flex-none min-w-[5.5rem] rounded bg-white/20 px-2 sm:px-3 py-1 text-xs sm:text-sm leading-tight font-semibold text-white hover:bg-white/30"
        >
          Nicht reproduzierbar
        </button>
        <button
          type="button"
          onClick={butlerBeenden}
          data-testid="butler-beenden"
          className="flex-1 sm:flex-none min-w-[5.5rem] rounded bg-white/95 px-2 sm:px-3 py-1 text-xs sm:text-sm leading-tight font-semibold text-red-700 hover:bg-white"
        >
          Butler beenden
        </button>
      </span>
      <FehlerGefundenDialog offen={!!dialog} art={dialog || "fehler"} onClose={() => setDialog(null)} />
    </div>
  );
}
